import { styled } from "@vitality-ds/system";
import BaseChipCheckboxStyles from "./styles/BaseChipCheckbox.styles";
import BaseChipCheckboxBoxStyles from "./styles/BaseChipCheckboxBox.styles";
import BaseChipCheckboxIconStyles from "./styles/BaseChipCheckboxIcon.styles";
export var BaseChipCheckbox = styled("button", BaseChipCheckboxStyles);
export var BaseChipCheckboxBox = styled("div", BaseChipCheckboxBoxStyles);
export var BaseChipCheckboxIcon = styled("div", BaseChipCheckboxIconStyles);